/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import { useQuery } from 'react-apollo';
import mbpLogger from 'mbp-logger';
import {
    string, func, object,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import findContent from '../../../../gql/queries/findContent';
import CelebrationsCustomsCardView from './CelebrationsCustomsCardView';
import GraphqlPortalLoader from '../../../../components/GraphqlComponents/GraphqlCommonComponents/GraphqlPortalLoader';

const styles = () => ({
    noHangtagLabel: {
        fontSize: 28,
        textAlign: 'center',
        padding: '24px 0px',
    },
});
const GraphlqlCelebrationsCustomsCard = ({
    classes, personalizationCustomsType, closeModal, updateCGCCustomsData, orderItemsId, openModal, customCardData, dataDictionary,
}) => {
    let customsContentType = 'labels';
    let customType = 'label';
    const pType = personalizationCustomsType?.substring(0, 2);
    if (pType === 'HT') {
        customsContentType = 'hangtags';
        customType = 'hangtag';
    }
    const query = `{\\"product_sku\\": \\"${orderItemsId}\\"}`;
    const CUSTOMS_QUERY = findContent({ brand: 'gci', contentType: customsContentType, query });
    const { data, error, loading } = useQuery(CUSTOMS_QUERY);
    let response = null;
    if (loading) {
        response = <GraphqlPortalLoader />;
    } else if (error || !data) {
        mbpLogger.logError({
            query: CUSTOMS_QUERY,
            component: 'GraphlqlCelebrationsCustomsCard.js',
            message: `Failed to fetch content data for: content type ${customsContentType},query ${query} on brand gci`,
            error,
        });
        response = null;
    } else if (data?.findContent?.content?.entries) {
        const customItems = data.findContent.content.entries?.[0];
        response = (
            customItems
                ? (
                    <CelebrationsCustomsCardView
                        key={customItems?.uid}
                        customsData={customItems}
                        closeModal={closeModal}
                        orderItemsId={orderItemsId}
                        customType={customType}
                        openModal={openModal}
                        updateCGCCustomsData={updateCGCCustomsData}
                        customCardData={customCardData}
                    />
                )
                : <p className={classes.noHangtagLabel}>{dataDictionary?.['No Hangtag or Label available for this Product'] || 'No Hangtag or Label available for this Product'}</p>
        );
    }
    return response;
};
GraphlqlCelebrationsCustomsCard.propTypes = {
    classes: object.isRequired,
    orderItemsId: string.isRequired,
    personalizationCustomsType: string.isRequired,
    closeModal: func.isRequired,
    updateCGCCustomsData: func.isRequired,
    dataDictionary: object,
};
GraphlqlCelebrationsCustomsCard.defaultProps = {
    dataDictionary: {},
};
export default (withStyles(styles)(GraphlqlCelebrationsCustomsCard));
